<template>
  <div class="nk-header nk-header-fixed ">
    <div class="container-lg wide-xl">
      <div class="nk-header-wrap">
        <div @click="goHome()" class="header-brand">
          <span class="header-brand-number">8.2</span>
          <span class="header-brand-separator"></span>
          <span class="header-brand-text">Inspect</span>
        </div>
        <div class="nk-header-tools">
          <ul class="nk-quick-nav">
            <li class="mr-2">
              <a href="#" class="nk-quick-nav-icon" @click.prevent="toggleDarkMode">
                <em class="icon material-icons">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</em>
              </a>
            </li>
            <LanguageSwitcher />
            <li class="dropdown user-dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <div class="user-toggle">
                  <div class="user-avatar sm user-avatar-custom">
                    <span>{{ userInitials }}</span>
                  </div>
                  <div class="user-name dropdown-indicator d-none d-sm-block">
                    {{ loginName }}
                  </div>
                </div>
              </a>
              <div
                class="
                  dropdown-menu
                  dropdown-menu-md
                  dropdown-menu-right
                  dropdown-menu-s1
                "
              >
                <div
                  class="
                    dropdown-inner
                    user-card-wrap
                    bg-lighter
                    d-none d-md-block
                  "
                >
                  <div class="user-card">
                    <div class="user-avatar user-avatar-custom">
                      <span>{{ userInitials }}</span>
                    </div>
                    <div class="user-info">
                      <span class="lead-text">{{ loginName }}</span>
                      <!-- <span class="sub-text">info@softnio.com</span> -->
                    </div>
                    <!--
                                                    <div class="user-action">
                                                        <a class="btn btn-icon mr-n2" href="html/subscription/profile-setting.html"><em class="icon ni ni-setting"></em></a>
                                                    </div>
                                                    -->
                  </div>
                </div>

                <div class="dropdown-inner">
                  <ul class="link-list">
                    <li>
                      <router-link :to="{ name: 'logout', params: {} }" tag="a">
                        <em class="icon ni ni-signout"></em
                        ><span>{{ $t('header_sign_out') }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <!-- .dropdown -->

            <li class="d-lg-none">
              <a
                href="#"
                class="toggle nk-quick-nav-icon mr-n1"
                @click="mobileMenu()"
                ><em class="icon ni ni-menu"></em
              ></a>
            </li>
          </ul>
          <!-- .nk-quick-nav -->
        </div>
        <!-- .nk-header-tools -->
      </div>
      <!-- .nk-header-wrap -->
    </div>
    <!-- .container-fliud -->
  </div>
</template>

<script>

import { EventBus } from '@/event-bus.js';
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: "Header",
  components: { LanguageSwitcher },
  computed: {
    companyName: function () {
      return this.$store.state.company;
    },
    loginName: function () {
      return this.$store.state.name;
    },
    isDarkMode: function () {
      return this.$store.getters.isDarkMode;
    },
    userInitials: function () {
      var name = this.$store.state.name || '';
      var parts = name.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
  },
  methods: {
    goHome: function () {
      this.$router.push({ name: "dashboard" });
    },
    mobileMenu: function() {
        EventBus.$emit('toggle:mobile:menu')
    },
    toggleDarkMode: function() {
      this.$store.dispatch('setDarkMode', !this.isDarkMode);
    }
  },
};
</script>

<style>
.user-avatar-custom {
  background: linear-gradient(135deg, #E8751A, #D06515) !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  letter-spacing: 0.02em;
}

.user-avatar-custom span {
  color: #fff !important;
}

.dark-mode .user-avatar-custom {
  background: linear-gradient(135deg, #E8751A, #D06515) !important;
}
</style>
